import { type CreateOrUpdateAlbumModel } from '@/shared/api'
import { formatDayjsToDateString } from '@/shared/lib/form-utils'

import { type AlbumFormCommonInformationModel } from '../ui/AlbumFormCommonInformation'

export function getAlbumRequestByFormValues(
  values: AlbumFormCommonInformationModel,
): CreateOrUpdateAlbumModel {
  return {
    name: values.name,
    type: values.type,
    authorId: values.authorId,
    coauthorIds: values.coauthorIds ?? null,
    pictureFileId: values.pictureFile?.id ?? '',
    releaseDate: values.releaseDate
      ? formatDayjsToDateString(values.releaseDate)
      : null,
    tagIds: [1],
    excludeSearch: values.excludeSearch,
  }
}
